import React, { FC } from 'react';
import { useCustomPageDataQuery } from '../hooks';
import { CustomPageWidgets } from '../widgets';
import { PUBLIC_CUSTOM_PAGE_PATH } from '../../../utils/const';

export const PrivacyStatement: FC = () => {
	const { data } = useCustomPageDataQuery(PUBLIC_CUSTOM_PAGE_PATH.privacyStatement);

	return <CustomPageWidgets widgets={data} />;
};
